import React, { useEffect, useState } from "react";
import BNBox from "../BNBox/BNBox";

interface BNTopLoaderProps {
  isLoading: boolean;
  bottom: string;
  position?: "fixed" | "absolute";
}

const BNHorizontalLoader: React.FC<BNTopLoaderProps> = ({ isLoading, bottom, position = "fixed" }) => {
  const [visible, setVisible] = useState(false);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setVisible(true);
      requestAnimationFrame(() => setFade(true));
    } else {
      setFade(false);
    }
  }, [isLoading]);

  const handleTransitionEnd = () => {
    if (!fade) {
      setVisible(false);
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <BNBox
      sx={{
        height: "0.6rem",
        position,
        bottom,
        left: 0,
        right: 0,
        opacity: fade ? 1 : 0,
        transition: "opacity 0.3s ease-in-out",
        overflow: "hidden",
        width: "100%",
      }}
      onTransitionEnd={handleTransitionEnd}
    >
      <svg
        className="no-color-invert"
        width="100%"
        height="2rem"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        viewBox="0 0 100 6"
      >
        <style>
          {`
            @keyframes moveRect {
              from {
                transform: translateX(-100%);
              }
              to {
                transform: translateX(100%);
              }
            }
            .moving-rect {
              animation: moveRect 1.5s linear infinite;
            }
          `}
        </style>
        <defs>
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: "#5FCBFA", stopOpacity: 1 }} />
            <stop offset="15%" style={{ stopColor: "#FDA4AA", stopOpacity: 1 }} />
            <stop offset="40%" style={{ stopColor: "#FDA4AA", stopOpacity: 1 }} />
            <stop offset="60%" style={{ stopColor: "#FDA4AA", stopOpacity: 1 }} />
            <stop offset="85%" style={{ stopColor: "#FDA4AA", stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: "#5FCBFA", stopOpacity: 1 }} />
          </linearGradient>
        </defs>

        <rect x="0" y="0" width="100" height="6" fill="#5FCBFA" />

        <rect x="0" y="0" width="100" height="6" fill="url(#grad1)" className="moving-rect" />
      </svg>
    </BNBox>
  );
};

export default BNHorizontalLoader;
